import { createGtm } from '@gtm-support/vue-gtm'
import router from './router'
import type { App } from 'vue'

export const setupGtm = (app: App) => {
  app.use(
    createGtm({
      id: 'GTM-K5TZ7WF',
      queryParams: {
        gtm_auth: import.meta.env.VITE_GTM_AUTH,
        gtm_cookies_win: import.meta.env.VITE_GTM_COOKIES_WIN,
        gtm_preview: import.meta.env.VITE_GTM_PREVIEW,
      },
      debug: import.meta.env.MODE !== 'production',
      vueRouter: router,
    })
  )
}
